
import styled from '@emotion/styled';


export const ProcessedWithdrawalsWrapper = styled('section', { label: 'ProcessedWithdrawalsWrapper' })`
    margin-top: 20px;
`;

export const SelectedFilterWrapper = styled('div', { label: 'SelectedFilterWrapper' })`
    display: flex;
    margin-bottom: 16px;
`;

export const MainContent = styled('div', { label: 'MainContent' })`
    width: 100%;
    height: auto;
`;
